module.exports = __webpack_public_path__ + "static/media/quote.93b9a044.svg";